import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { ErrorState } from '@/components/domain/ErrorState';
import { AuthLayout } from '@/features/auth/AuthLayout';
import { InviteForm } from '@/features/auth/InviteForm';
import { useT } from '@/i18n/useT';
import type { ApiError } from '@/lib/api';

export const Route = createFileRoute('/invite/$token')({
  component: InvitePage,
});

function InvitePage() {
  const t = useT();
  const { token } = Route.useParams();
  const [invalid, setInvalid] = useState<ApiError | null>(null);

  if (invalid) {
    return (
      <main className="flex min-h-svh items-center justify-center p-6">
        <ErrorState error={invalid} />
      </main>
    );
  }

  return (
    <AuthLayout title={t('auth.invite.title')} description={t('auth.invite.subtitle')}>
      <InviteForm token={token} onInvalid={setInvalid} />
    </AuthLayout>
  );
}
